//
//
//
//
//
//
//
//
//
//
//
//

import ImportDialogWidget from "./ImportDialogWidget.vue";
import { mapActions } from "vuex";

const IMPORT_TYPE_SUPPLIER_PRICES = 1;
const NOT_FOUND_CREATE_NEW = 1;
const NOT_FOUND_SKIP_LINE = 2;

const NOT_FOUND_OPTIONS = [
  { label: "Opprett nytt produkt", value: NOT_FOUND_CREATE_NEW },
  { label: "Hopp over linjen", value: NOT_FOUND_SKIP_LINE }
];

const FIELD_OPTIONS_PRODUCT_KEY = [
  { label: "Produktnr.", value: "ProductNumber" },
  { label: "Gtin/EAN", value: "Ean" },
  { label: "Strekkode", value: "Barcode" }
];

const MAPPING_FIELDS = [
  {
    label: null,
    name: "ProductKey",
    fieldOptions: FIELD_OPTIONS_PRODUCT_KEY,
    selectedField: null,
    column: null,
    required: true,
    fieldErrorMessage: "Vennligst velg produktnøkkel.",
    columnErrorMessage: "Vennligst velg en kolonne.",
    errors: {}
  },
  {
    label: "Pris",
    name: "Price",
    column: null,
    errors: {}
  },
  {
    label: "Ledetid",
    name: "LeadTime",
    column: null,
    errors: {}
  },
  {
    label: "Bestillingskvantum",
    name: "OrderQuantity",
    column: null,
    errors: {}
  },
  {
    label: "Lev. produkntnummer",
    name: "SupplierProductNumber",
    required: true,
    column: null,
    errors: {}
  }
];

const SETTINGS_CONFIG = [
  {
    name: "supplierId",
    type: "select",
    label: "Leverandør",
    options: [],
    optionLabel: "label",
    optionValue: "id",
    required: true,
    errorMessage: "Vennligst velg en leverandør.",
    filterable: true,
    filteredOptions: []
  },
  {
    name: "notFound",
    type: "select",
    label: "Håndtering ved ingen treff",
    options: NOT_FOUND_OPTIONS,
    required: true,
    errorMessage: "Vennligst velg en håndtering ved ingen treff.",
    filterable: false
  },
  {
    name: "headerLine",
    type: "toggle",
    label: "Overskriftslinje",
    default: true
  }
];

export default {
  components: {
    ImportDialogWidget
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      IMPORT_TYPE_SUPPLIER_PRICES,
      mappingFields: JSON.parse(JSON.stringify(MAPPING_FIELDS)),
      settings: {
        supplierId: null
      },
      settingsConfig: JSON.parse(JSON.stringify(SETTINGS_CONFIG)),
      description: `
        <p>
          Rutinen leser inn leverandørpriser.
          Utfylte felt skrives over/opprettes. Koblede felt i tabellen
          behandles. Rutinen behandler filer i excel-format.
        </p>
      `
    };
  },
  methods: {
    ...mapActions("main", ["getSuppliers"]),
    async fetchSuppliers() {
      const suppliers = await this.getSuppliers();
      const supplierSetting = this.settingsConfig.find(
        s => s.name === "supplierId"
      );
      if (supplierSetting) {
        supplierSetting.options = suppliers.map(supplier => ({
          ...supplier,
          label: `${supplier.number || supplier.supplierNumber}: ${
            supplier.name
          }`
        }));
      }
    }
  },
  mounted() {
    this.fetchSuppliers();
  }
};
